// extracted by mini-css-extract-plugin
export default {"popup":"empowermentAndUnstoppablePopup_popup__x+NQ3","content":"empowermentAndUnstoppablePopup_content__eZnte","aboveText":"empowermentAndUnstoppablePopup_aboveText__xFA5S"};